// extracted by mini-css-extract-plugin
export default {"loading":"LoadingWrapper_loading__GpCoC","pulse":"LoadingWrapper_pulse__H7fkK"};